import { jwtDecode } from 'jwt-decode';
const API_BASE = process.env.REACT_APP_API_URL;
const CATEGORIA_API_URL = `${API_BASE}Categoria`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

export async function getCategoriasByArea(areaId) {
  try {
    const res = await fetch(`${CATEGORIA_API_URL}/por-area/${areaId}`, {
      headers: getAuthHeaders()
    });
    
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    
    const data = await res.json();
    return data;
  } catch (error) {
    console.error('Error en getCategoriasByArea:', error);
    throw error;
  }
}

export function createCategoria(areaId) {
  return async (values, onDone) => {
    try {
      await fetch(CATEGORIA_API_URL, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({
          ...values,
          area_id: areaId
        })
      });
      onDone(true);
    } catch {
      onDone(false);
    }
  };
}

export function editCategoria() {
  return async (row, values, onDone) => {
    try {
      await fetch(`${CATEGORIA_API_URL}/${row.id_categoria}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify({
          nombre: values.nombre,
          descripcion: values.descripcion,
          estado: Number(values.estado),
          usuarioEdicion: (() => {
            try {
              const token = localStorage.getItem('authToken');
              if (!token) return null;
              const decoded = jwtDecode(token);
              return decoded?.userId ?? null;
            } catch {
              return null;
            }
          })(),
          area_id: row.area_id ?? row.id_area ?? null
        })
      });
      onDone(true);
    } catch {
      onDone(false);
    }
  };
}

export function deleteCategoria() {
  return async (row, onDone) => {
    try {
      await fetch(`${CATEGORIA_API_URL}/${row.id_categoria}`, {
        method: 'DELETE',
        headers: getAuthHeaders()
      });
      onDone(true);
    } catch {
      onDone(false);
    }
  };
}

export async function getCategorias() {
  const res = await fetch(CATEGORIA_API_URL, {
    headers: getAuthHeaders()
  });
  return await res.json();
}

export async function createCategoriaGeneral(values) {
  try {
    await fetch(CATEGORIA_API_URL, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        area_id: Number(values.area_id),
        nombre: values.nombre,
        descripcion: values.descripcion,
        estado: Number(values.estado)
      })
    });
    return true;
  } catch {
    return false;
  }
}

export async function editCategoriaGeneral(id, values) {
  try {
    await fetch(`${CATEGORIA_API_URL}/${id}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        area_id: Number(values.area_id),
        nombre: values.nombre,
        descripcion: values.descripcion,
        estado: Number(values.estado),
        usuarioEdicion: (() => {
          try {
            const token = localStorage.getItem('authToken');
            if (!token) return null;
            const decoded = jwtDecode(token);
            return decoded?.userId ?? null;
          } catch {
            return null;
          }
        })()
      })
    });
    return true;
  } catch {
    return false;
  }
}

export async function deleteCategoriaGeneral(id) {
  try {
    await fetch(`${CATEGORIA_API_URL}/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    return true;
  } catch {
    return false;
  }
}
